import { C } from '../actions/index';
import { BillingFormState, BillingFormFieldNames } from 'utils/constants';
import { generateMonth, validateForm } from 'utils/utils';


const defaultFormFields = {
  billingAddressName: '',
  billingStreetAddress: '',
  billingCity: '',
  billingState: '',
  billingZipcode: '',
  billingCountry: 'US',
  shippingAddressName: '',
  shippingStreetAddress: '',
  shippingCity: '',
  shippingState: '',
  shippingZipcode: '',
  shippingCountry: 'US',
  cardName: '',
  cardNumber: '',
  expireMonth: generateMonth(),
  expireYear: '2018',
  cvc: '',
  selectedCC: false,
  selectedPaymentMethod: 'cc',  //the options here are 'cc' and 'paypal'
  saveCC: false,
  promoCode: '',
  shippingStateReq: true,
  billingStateReq: true,
  email: '',
  password: '',
  referral: '',
  other_referral_answer: ''
};

const initialCartState = {
  cartItems: [],
  billingState: BillingFormState.SHIPPING,
  formFields: Object.assign({}, defaultFormFields),
  addressSame: false,
  tokenIsPending: false,
  tokenError: null,
  orderIsPending: false,
  orderError: null,
  orderSuccess: false,
  orderNumber: null,
  orderId: null,
  updateIsPending: false,
  updateError: null,
  getCartIsPending: false,
  getCartError: null,
  cartNotification: false,
  removeList: {},
  paymentTotals: {
    displayedCurrency: 'USD',
    displayedSubtotal: 0,
    displayedTax: 0,
    displayedDiscount: 0,
    displayedShipping: 0,
    displayedTotal: 0
  },
  confirmMode: false,
  formError: null,
  errorOrderToken: null,
  checks: {},
  isOther: false,
  credits: {
    fetching: false,
    informed: false,
    balance: 0,
    results: []
  }
};

export const cart = (state = initialCartState, action) => {
  switch (action.type) {
    case C.TOGGLE_CONFIRM_ORDER: {
      if (!action.payload) {
        return Object.assign({}, state, {
          confirmMode: false,
          formError: null
        });
      }

      if (action.payload) {
        const formError = validateForm(
          state.formFields,
          state.addressSame,
          action.payload.fromWhichCart
        );
        if (formError) {
          return Object.assign({}, state, { formError });
        }
      }

      return Object.assign({}, state, { confirmMode: true, formError: null });
    }
    case C.TOGGLE_ADDRESS_SAME:
      return Object.assign({}, state, { addressSame: !state.addressSame });
    case C.UPDATE_PAYMENT_TOTALS:
      return Object.assign({}, state, { paymentTotals: action.payload });
    case C.CHANGE_REMOVE_LIST: {
      const removeList = Object.assign({}, state.removeList);
      removeList[action.payload.index] = action.payload.add;
      return Object.assign({}, state, { removeList });
    }
    case C.TOGGLE_CART_NOTIFICATION:
      return Object.assign({}, state, { cartNotification: action.payload });
    case C.ADD_ITEM: {
      const cartItems = Object.assign([], state.cartItems);
      cartItems.push(action.payload);
      return Object.assign({}, state, { cartItems, cartNotification: true });
    }
    case C.REMOVE_ITEM: {
      const index = action.payload;
      const cartItems = [
        ...state.cartItems.slice(0, index),
        ...state.cartItems.slice(index + 1)
      ];
      if (state.cartItems.length < 1) {
        return Object.assign({}, state, {
          confirmMode: false,
          formError: null
        });
      }
      return Object.assign({}, state, { cartItems });
    }
    case C.CHANGE_ITEM_QTY: {
      const cartItemsQty = Object.assign([], state.cartItems);
      const cartItem = cartItemsQty[action.payload.index];
      cartItem.qty = action.payload.qty;
      let cartItemPrice = 0;
      const product = cartItem.extra.product;
      if (product) {
        cartItemPrice = parseFloat(
          product.current_price ||
          product.currentPrice ||
          product.promo_price ||
          product.promoPrice ||
          product.price
        );
      } else {
        cartItemPrice = cartItem.extra.package.price;
      }
      cartItem.subtotal = action.payload.qty * cartItemPrice;
      return Object.assign({}, state, { cartItems: cartItemsQty });
    }
    case C.TOGGLE_BILLING_INFO:
      return Object.assign({}, state, { billingState: action.payload });
    case C.CHANGE_FORM: {
      const form = Object.assign({}, state.formFields);
      form[action.payload.field] = action.payload.newValue;
      if (action.payload.field === BillingFormFieldNames.SHIPPING_COUNTRY) {
        if (action.payload.newValue === 'US') {
          form[BillingFormFieldNames.SHIPPING_STATE] = 'CA';
          form.shippingStateReq = true;
        } else if (action.payload.newValue === 'CA') {
          form[BillingFormFieldNames.SHIPPING_STATE] = 'BC';
          form.shippingStateReq = true;
        } else {
          form[BillingFormFieldNames.SHIPPING_STATE] = '';
          form.shippingStateReq = false;
        }
      } else if (
        action.payload.field === BillingFormFieldNames.BILLING_COUNTRY
      ) {
        if (action.payload.newValue === 'US') {
          form[BillingFormFieldNames.BILLING_STATE] = 'CA';
          form.billingStateReq = true;
        } else if (action.payload.newValue === 'CA') {
          form[BillingFormFieldNames.BILLING_STATE] = 'BC';
          form.billingStateReq = true;
        } else {
          form[BillingFormFieldNames.BILLING_STATE] = '';
          form.billingStateReq = false;
        }
      }
      if (action.payload.field === 'referral') {
        if (action.payload.newValue === 30){
          state.isOther = true;
        } else {
          state.isOther = false;
          form.other_referral_answer = '';
        }
      }
      return Object.assign({}, state, { formFields: form });
    }
    case C.STRIPE_TOKEN:
      return Object.assign({}, state, {
        tokenIsPending: true,
        orderNumber: null,
        orderSuccess: false,
        formError: null
      });
    case C.STRIPE_TOKEN_FAIL:
      return Object.assign({}, state, {
        tokenIsPending: false,
        tokenError: action.error
      });
    case C.STRIPE_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        tokenIsPending: false,
        tokenError: null,
        orderIsPending: true
      });
    case C.ORDER_FAIL: {
      let errorOrderToken = state.errorOrderToken
        ? state.errorOrderToken.slice()
        : null;
      if (action.error.order_token) {
        errorOrderToken = action.error.order_token;
      }

      const couponCode =
        (action.error.message === 'Coupon code is not valid.' ||
          action.error.message === 'Coupon code does not apply to any of the packages.')
          ? ''
          : state.formFields.promoCode;
      const formFields = Object.assign({}, state.formFields, {
        promoCode: couponCode
      });

      return Object.assign({}, state, {
        orderIsPending: false,
        orderError: action.error,
        errorOrderToken,
        formFields
      });
    }
    case C.ORDER_SUCCESS:
      return Object.assign({}, state, {
        orderIsPending: false,
        orderError: null,
        orderSuccess: true,
        orderNumber: action.payload.order_number,
        orderId: action.payload.order_id,
        formFields: defaultFormFields,
        addressSame: false,
        cartItems: [],
        confirmMode: false,
        errorOrderToken: null
      });
    case C.LEAVE_ORDER_CONFIRM:
      return Object.assign({}, state, {
        orderSuccess: false,
        orderNumber: null,
        isOpen: false,
        confirmMode: false,
        billingInfoOpen: true,
        tokenError: null,
        orderError: null,
        errorOrderToken: null
      });
    case C.UPDATE_CART:
      return Object.assign({}, state, { updateIsPending: true });
    case C.UPDATE_CART_FAIL: {
      const couponCode =
        (action.error.message === 'Coupon code is not valid.' ||
          action.error.message === 'Coupon code does not apply to any of the packages.')
          ? ''
          : state.formFields.promoCode;
      const formFields = Object.assign({}, state.formFields, {
        promoCode: couponCode
      });
      const displayedInfo = action.error.displayedInfo;

      return Object.assign({}, state, {
        updateIsPending: false,
        updateError: action.error,
        paymentTotals: displayedInfo,
        formFields
      });
    }
    case C.UPDATE_CART_SUCCESS:
      return Object.assign({}, state, {
        updateIsPending: false,
        updateError: null,
        cartItems: action.payload.orderItems,
        paymentTotals: action.payload.displayedInfo
      });
    case C.GET_CART:
      return Object.assign({}, state, { getCartIsPending: true });
    case C.GET_CART_SUCCESS:
      // if there is >0 previousCCs on the api response, set `selectedCC` to the first one
      if(action.payload.previousCreditsCards.length){
        state.formFields.selectedCC = action.payload.previousCreditsCards[0].id
      }
      return Object.assign({}, state, {
        getCartIsPending: false,
        getCartError: null,
        cartItems: action.payload.orderItems,
        paymentTotals: action.payload.displayedInfo,
        previousCreditsCards: action.payload.previousCreditsCards
      });
    case C.GET_CART_FAIL:
      return Object.assign({}, state, {
        getCartIsPending: false,
        getCartError: action.error
      });
    case C.OPEN_UPGRADE:
      return Object.assign({}, state, { isOpen: false });
    case C.ADD_STYLEBOARD_INFO: {
      const cartItems = state.cartItems.map((item, index) => {
        return Object.assign({}, item, {
          extra: {
            ...item.extra,
            spaceInfo: action.payload
          }
        });
      });

      return Object.assign({}, state, { cartItems });
    }
    case C.TOGGLE_CHECK:
      return Object.assign({}, state, {
        checks: Object.assign({}, state.checks, action.payload)
      });
    case C.UPDATE_CART_CREDITS:
      return Object.assign({}, state, {
        credits: {
          fetching: true
        }
      });
    case C.UPDATE_CART_CREDITS_SUCCESS:
      return Object.assign({}, state, {
        credits: Object.assign({}, action.payload, {
          fetching: false,
          informed: false
        })
      });
    case C.UPDATE_CART_CREDITS_FAIL:
      return Object.assign({}, state, {
        credits: {
          fetching: false,
          informed: false
        }
      });
    case C.SET_INFORMED_CREDITS:
      const credits = Object.assign({}, state.credits, {
        informed: action.payload
      });
      return Object.assign({}, state, { credits });
    default:
      return state;
  }
};
